<template>
  <el-dialog :visible.sync="showModal" :close-on-click-modal="false" :destroy-on-close="true" append-to-body width="30%">
    <el-form ref="submitFirstForm" :model="submitFirstForm">
      <h3>小红书证明链接</h3>
      <el-form-item prop="title" :rules="{ required: true, message: '请输入证明链接', trigger: 'blur' }">
        <el-input placeholder="" v-model="submitFirstForm.title" style="width: 300px;" />
      </el-form-item>
     
      <h3>测评截图</h3>
      <el-form-item prop="cover_img"
        :rules="{ required: true, message: '请上传至少一项图片/视频', trigger: 'blur' }">
        <upload-list :list="submitFirstForm.cover_img" width="150px" height="150px"></upload-list>
      </el-form-item>
      <div style="margin-top: 40px;display: flex;align-items: center;
justify-content: center;">
        <el-button @click="showModal = false">返回</el-button>
        <el-button type="primary" :loading="submitting" @click="onSubmitFirst('submitFirstForm')">提交</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import UploadList from "@/components/UploadList/index.vue";
import Tinymce from "@/components/Tinymce";
import { zhongcao } from "@/api/order";

export default {
  data: () => ({
    submitFirstForm: {
      
      cover_img: [],
    },
    submitting: false,
  }),
  components: { 
        UploadList,Tinymce },
  props: {
    // 展示
    show: {
      default: false,
      type: Boolean,
    },
    draftData: Object,
  },
  methods: {
    trunOff() {
      this.showModal = false;
    },
    onSubmitFirst(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            this.submitting = true;
            // await zhongcao.firstDraftReview({ type: 2, ...this.form });
            this.$message({
              message: "已驳回初稿!",
              type: "success",
            });
            this.$emit("onUpdate");
            this.trunOff();
          } catch {
            this.$message.error("出错了!");
          } finally {
            this.submitting = false;
          }
        }
      });
    },

  },
  computed: {
    showModal: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
  // watch: {
  //     show(val) {
  //         if (val) {
  //             this.form.order_id = this.draftData.order_id
  //         }
  //     }
  // },
  created() {

  },
};
</script>

<style lang="scss">
.media-box {
  margin: -5px;

  .video-box {
    position: relative;
    display: inline-block;
    width: 150px;
    height: 150px;
    margin: 5px;
    border: 1px dashed #d1e9ff;
    border-radius: 3px;
    cursor: pointer;

    .play-icon {
      font-size: 3rem;
      color: white;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
}

.article-box {
  display: flex;
  align-items: flex-start;

  .article-name {
    font-size: 1rem;
    margin: 0;
    margin-left: 10px;
  }
}

.reject-content {
  overflow: hidden;

  &>p:first-child,
  &>p:last-child {
    margin: 0;
  }

  img {
    width: 100%;
    height: auto;
  }
}

.option-box {
  margin-top: 18px;
}
</style>
